import { CloseIcon } from '@velasca/icons/close'
import { CartTitle } from '../../CartTitle/CartTitle'
import { Button, Line } from './Header.styles'
import type { HeaderProps } from './Header.types'

export const Header = ({ onClose, title }: HeaderProps): JSX.Element => {
  return (
    <Line>
      <div></div>
      <CartTitle title={title} />
      <Button onClick={onClose}>
        <CloseIcon width="20" height="20" />
      </Button>
    </Line>
  )
}
